import React from "react";

import Popover from "@material-ui/core/Popover";
import Typography from "@material-ui/core/Typography";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Slider from "@material-ui/core/Slider";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    width: 260,
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1.5),
  },
  section: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(0.5),
  },
  label: {
    fontSize: 12,
    fontWeight: 600,
    color: theme.palette.text.secondary,
  },
}));

// Popover de configurações. Persistência é responsabilidade do orquestrador.
const SettingsMenu = ({
  anchorPosition,
  open,
  onClose,
  settings,
  onChange,
}) => {
  const classes = useStyles();

  const set = (patch) => onChange({ ...settings, ...patch });

  return (
    <Popover
      open={open}
      anchorReference="anchorPosition"
      anchorPosition={anchorPosition || { top: 0, left: 0 }}
      onClose={onClose}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <div className={classes.root}>
        <div className={classes.section}>
          <Typography className={classes.label}>Variante visual</Typography>
          <FormControl variant="outlined" size="small" margin="dense">
            <Select
              value={settings.variant}
              onChange={(e) => set({ variant: e.target.value })}
            >
              <MenuItem value="sunlit">Sunlit</MenuItem>
              <MenuItem value="funnel">Funil</MenuItem>
              <MenuItem value="soft">Soft</MenuItem>
            </Select>
          </FormControl>
        </div>

        <div className={classes.section}>
          <Typography className={classes.label}>Densidade</Typography>
          <FormControl variant="outlined" size="small" margin="dense">
            <Select
              value={settings.densidade}
              onChange={(e) => set({ densidade: e.target.value })}
            >
              <MenuItem value="rico">Rico</MenuItem>
              <MenuItem value="compacto">Compacto</MenuItem>
            </Select>
          </FormControl>
        </div>

        <div className={classes.section}>
          <Typography className={classes.label}>
            Limite de SLA: {settings.slaLimite} min
          </Typography>
          <Slider
            value={settings.slaLimite}
            min={15}
            max={240}
            step={15}
            valueLabelDisplay="auto"
            onChange={(_, v) => set({ slaLimite: Array.isArray(v) ? v[0] : v })}
          />
        </div>

        <FormControlLabel
          control={
            <Switch
              checked={settings.mostrarMetricas}
              onChange={(e) => set({ mostrarMetricas: e.target.checked })}
              color="primary"
            />
          }
          label={
            <Typography className={classes.label}>Mostrar métricas</Typography>
          }
        />
      </div>
    </Popover>
  );
};

export default SettingsMenu;
